export const ADMIN_ADDRESS = "8hGNs4zJZ1ef5rNVpmeH5cczj49qgusaeEj56E5fqzrf";
export const PROJECT_VAULT_ADDRESS = "8CgCTyVCYDxUmVs4TN5YLnZ9KgLmWzuNDLcYbDKkU1ZW";
export const SOL = "solana";
export const USDC = "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const PROD_AUTH_PROVIDER = "privy_custom";